import Vue from 'vue';
import Router from 'vue-router';
import index from './views/index.vue';
import floorpage from './views/FloorPage.vue';
import userRegister from './views/userAgree/UserRegister.vue';
import userPrivacy from './views/userAgree/UserPrivacy.vue';
import userPrivacy2 from './views/userAgree/UserPrivacy2.vue';
import test from './views/active/test/index.vue';
import testDetail from './views/active/test/detail.vue';
import testResult from './views/active/test/result.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
    },
    {
      path: '/floorpage',
      name: 'floorpage',
      component: floorpage,
    },
    {
      path: '/userRegister',
      name: 'userRegister',
      component: userRegister,
    },
    // 吉日历
    {
      path: '/userPrivacy',
      name: 'userPrivacy',
      component: userPrivacy,
    },
    // 诸葛万年历
    {
      path: '/userPrivacy2',
      name: 'userPrivacy2',
      component: userPrivacy2,
    },
    {
      path: '/page1',
      name: 'page1',
      component: () => import('./views/page1/page1.vue'),
      children: [
        {
          path: '/page1/:path*',
          component: () => import('./views/page1/page1.vue'),
        },
      ],
    },
    {
      path: '/active/test',
      name: 'ActiveTest',
      component: test,
    },
    {
      path: '/active/test/detail',
      name: 'ActiveTestDetail',
      component: testDetail,
    },
    {
      path: '/active/test/result',
      name: 'ActiveTestResult',
      component: testResult,
    },
  ],
});


// 根据具体的跳转类型更改跳转属性值，执行不同的动画
const nextDirection = (direction) => {
  const el = document.getElementById('app');
  if (el) el.setAttribute('transition-direction', direction);
};
router._push = router.push;
// 重写路由跳转方法，设置跳转类型后跳转
router.forward = router.push = (target) => {
  nextDirection('forward');
  setTimeout(() => { router._push(target); });
};
// 重写路由返回方法，设置跳转类型后返回
router.back = (target) => {
  nextDirection('back');
  if (target) setTimeout(() => { router._push(target); });
};

const beforeEach = (to, from, next) => {
  window.document.title = to.meta.title ? to.meta.title : '日历';
  // 路由切换动画效果
  const toRouter = to.path;
  const toName = to.name;
  const fromRouter = from.path;
  const h = JSON.parse(sessionStorage.getItem(toRouter));
  if (h && h.history) {
    nextDirection('back');
    h.history = false;
    sessionStorage.setItem(toRouter, JSON.stringify(h));
  } else {
    sessionStorage.setItem(fromRouter, JSON.stringify({
      history: true,
      from: fromRouter,
    }));
    // 指定界面定制路由控制
    const toRouterName = [];
    if (toName && toRouterName.indexOf(toName) > -1) {
      sessionStorage.setItem(fromRouter, JSON.stringify({
        history: false,
        from: fromRouter,
      }));
    }
    nextDirection('forward');
  }
  next();
};
router.beforeEach(beforeEach);

export default router;
